import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import axios from "axios";
import DelayLink from "../../../helpers/delayLink";
import Fade from "react-reveal/Fade";
import Slider from "react-slick";
import ProgressiveImage from "react-progressive-image";

class StoreTypeSlider extends Component {
  state = {
    primary_types: [],
    secondary_types: [],
    total_types: [],
  };

  componentDidMount() {
    const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
    axios
      .post("https://pykin.in/public/api/get-store-types", {
        latitude: userSetAddress.lat,
        longitude: userSetAddress.lng,
      })
      .then((response) => {
        const types = response.data;

        this.setState({
          primary_types: types.primary,
          secondary_types: types.secondary,
          total_types: types.total_types,
        });

      });
  }

  render() {
    
    return (
      <React.Fragment>
        {this.state.total_types.length === 0 ? (
          <ContentLoader
            speed={2}
            width={400}
            height={123}
            viewBox="0 0 400 123"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="20" y="22" rx="0" ry="0" width="163" height="102" />
            <rect x="198" y="22" rx="0" ry="0" width="163" height="102" />
          </ContentLoader>
        ) : (
          <React.Fragment>
            <div className="d-flex" style={{ width: "100%" }}>
            {this.state.primary_types.length > 0 &&
                this.state.primary_types.map((type, index) => (
                  <DelayLink
                    to={type.mode == 1 ? "/store-type/" + type.id : "/single-store/" + type.id}
                    delay={200}
                    index={index}

                    className=" text-center"
                    style={{
                      backgroundColor: "#fffff",
                      position: "relative",
                      marginLeft: "2.5%",
                      marginRight: "2%",
                    }}
                  >
                    <ProgressiveImage
                      delay={100}
                      src={`${localStorage.getItem("cdn") + type.image}`}
                      placeholder={
                        "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/blue_placeholder"
                      }
                    >
                      {(src, loading) => (
                        <img
                          src={src}
                          style={{
                            height: "86px",
                            width: "100%",
                            borderRadius: "9vw",
                          }}
                          alt={"pic"}
                        />
                      )}
                    </ProgressiveImage>
                    <p style={{
                      fontFamily: 'Poppins',
                      fontSize: '13px',
                      fontStyle: 'normal',
                      fontWeight: 500,
                      marginBottom: '0px',

                    }} className="mt-1">{type.name}</p>

                  </DelayLink>
                ))}
            </div>

            <div className="d-flex" style={{width: '100%',marginTop: '4%',justifyContent: 'space-around'}}>
            {this.state.secondary_types.length > 0 &&
                this.state.secondary_types.map((type_two, index) => (
                  <DelayLink
                  to={type_two.mode == 1 ? "/store-type/" + type_two.id : "/single-store/" + type_two.id}
                  delay={200}
                  index={index}
                    className=" text-center"
                    style={{
                      backgroundColor: "#fffff",
                      position: "relative",
                      marginLeft: "2.5%",
                      marginRight: "2%",
                      width: '25%',
                    }}
                  >
                    <ProgressiveImage
                      delay={100}
                      src={`${localStorage.getItem("cdn") + type_two.image}`}
                      placeholder={
                        "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/blue_placeholder"
                      }
                    >
                      {(src, loading) => (
                        <img
                          src={src}
                          style={{"height":"20vw","width":"20vw","borderRadius":"5vw"}}
                          alt={"pic"}
                        />
                      )}
                    </ProgressiveImage>
                    <p style={{
                      fontFamily: 'Poppins',
                      fontSize: '14px',
                      fontStyle: 'normal',
                      "letterSpacing":"-0.7px",
                      fontWeight: 500,
                      marginTop: "0.4rem",
                      marginBottom: '0px',
                    }} className="mt-1">{type_two.name}</p>

                  </DelayLink>
                ))}
                     </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default StoreTypeSlider;
